
import { Component, Vue, Watch } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { API_TCompanies, API_TCompany, API_TCompany_Filter } from "@/models/cases_expert_companies";
import { TTab } from "@/models/tabs";
import { COMPANY_TABS_VALUES, COMPANY_TABS, COMPANY_TAB } from "@/constants/compliance";

const TABLE_INITIAL_LIMIT = 20;
const TABLE_INITIAL_OFFSET = 0;
const TABLE_INITIAL_ORDER = "desc";
const TABLE_INITIAL_ORDER_BY = "id";

type ParamsKeyObject = {
  [key: string]: any;
};

@Component({
  components: {
    Tabs: () => import("@/components/Tabs/Tabs.vue"),
    ExpertCompaniesTable: () =>
      import("@/modules/Services/Components/Table/ExpertCompaniesTable.vue"),
    TableSearchbar: () => import("@/components/TableSearchbar/TableSearchbar.vue"),
  },
})
export default class Companies extends Vue {
  loading = false;

  loadingFilters = false;

  items: API_TCompany[] = [];

  filters: API_TCompany_Filter = {
    compliance_status: [],
    compliance_subscription: [],
  };

  params: ParamsKeyObject = {
    limit: TABLE_INITIAL_LIMIT,
    order: TABLE_INITIAL_ORDER,
    orderBy: TABLE_INITIAL_ORDER_BY,
    offset: TABLE_INITIAL_OFFSET,
    search: "",
    list_name: COMPANY_TAB,
  };

  total = 0;

  async mounted() {
    await this.fetchTableFilters();
  }

  tabDigits = {
    all: 0,
    premium: 0,
  };

  async fetchTableCompanies({ params, isLimit }: { params: ParamsKeyObject; isLimit: boolean }) {
    try {
      this.loading = true;

      const { data } = await this.axios.get<API_TCompanies>(
        API_ROUTES.EXPERT_COMPANIES_BY_FILTER(params)
      );

      this.total = data.total_count;

      if (!data.companies.length && !isLimit) return (this.items = []);

      const items = data.companies;

      this.items = isLimit ? [...this.items, ...items] : data.companies;

      this.tabDigits.all = data.companies_tab_counts.all_count || 0;
      this.tabDigits.premium = data.companies_tab_counts.premium_count || 0;
    } finally {
      this.loading = false;
    }
  }

  async fetchTableFilters() {
    try {
      this.loadingFilters = true;

      const { data } = await this.axios.get<API_TCompany_Filter>(
        API_ROUTES.EXPERT_COMPANIES_FILTERS()
      );

      if (!data) return;

      this.filters = data;
    } finally {
      this.loadingFilters = false;
    }
  }

  async updateQuery(payload?: { params: ParamsKeyObject; isLimit: boolean }) {
    this.params.offset = 0;

    const requestParams = payload ?? { params: this.params, isLimit: false };

    await this.fetchTableCompanies(requestParams);
  }

  tabNames: string[] = COMPANY_TABS_VALUES;

  currentTabName = this.tabNames[0];

  componentKey = 0;

  get tabs(): TTab[] {
    return this.tabNames.map((name) => ({
      label: COMPANY_TABS[name].toUpperCase(),
      isActive: this.currentTabName === name,
      digit: this.tabDigits[name],
      action: () => {
        this.currentTabName = name;
        this.componentKey += 1;
      },
    }));
  }

  @Watch("currentTabName", { immediate: true })
  async currentTabNameChanged(value: string) {
    this.params = {
      limit: TABLE_INITIAL_LIMIT,
      order: TABLE_INITIAL_ORDER,
      orderBy: TABLE_INITIAL_ORDER_BY,
      offset: TABLE_INITIAL_OFFSET,
      search: this.params.search,
      list_name: value,
    };

    await this.fetchTableCompanies({ params: this.params, isLimit: false });
  }
}
